var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { sampleData } from '../../components/HoverListWithTabs/data';
import { SwiperSlide } from 'swiper/react';
import { TwoCards } from '../hoverListTabChildComponent/TwoCards';
import CardCarousel from '../../components/hoverListCarousel/Index';
import './HoverNumberedList.scss';
export var HoverListWithTabs = function (_a) {
    var _b = _a.data, data = _b === void 0 ? sampleData : _b;
    var _c = useState(0), listNumber = _c[0], updateListNumber = _c[1];
    var _d = useState(0), itemNumber = _d[0], updateItemNumber = _d[1];
    var _e = useState(0), containerWidth = _e[0], updateContainerWidth = _e[1];
    var _f = useState(0), totalElementWidth = _f[0], updateElementsWidth = _f[1];
    // const [hoverList, updateHoverList] = useState([]);
    var isMobile = window.innerWidth < 768;
    var isTablet = window.innerWidth <= 1020;
    var isDesktop = window.innerWidth >= 975;
    var elements;
    useEffect(function () {
        setTimeout(function () {
            var _a;
            elements = Array.from(document.getElementsByClassName('hover-list-tab'));
            var container = Array.from(document.getElementsByClassName('hover-list-tabs-container'));
            var swiperElement = Array.from((_a = container[0]) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('swiper-wrapper'));
        });
    }, []);
    var handleClickRight = function () {
        var _a, _b, _c;
        updateItemNumber(itemNumber + 1);
        var tabElements = Array.from(document.getElementsByClassName('hover-list-tab'));
        var container = Array.from(document.getElementsByClassName('hover-list-tabs-container'));
        var swiperElement = Array.from((_a = container[0]) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('swiper-wrapper'));
        (_b = swiperElement[0]) === null || _b === void 0 ? void 0 : _b.setAttribute('style', 'overflow-x:hidden');
        (_c = swiperElement[0]) === null || _c === void 0 ? void 0 : _c.setAttribute('style', "transform: translate3d(20px, 0px, 0px) !important");
    };
    var updateIndex = function (index) {
        updateListNumber(index);
    };
    useEffect(function () {
        setTimeout(function () {
            var _a, _b, _c, _d;
            var container = Array.from(document.getElementsByClassName('hover-list-tabs-container'));
            var mainDiv = Array.from(document.getElementsByClassName('flex snap-x snap-mandatory'));
            (_a = mainDiv[0]) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('hover-list-tab');
            var swiper = Array.from((_b = container[0]) === null || _b === void 0 ? void 0 : _b.getElementsByClassName('swiper swiper-initialized'));
            var swiperElement = Array.from((_c = container[0]) === null || _c === void 0 ? void 0 : _c.getElementsByClassName('swiper-wrapper'));
            (_d = swiperElement[0]) === null || _d === void 0 ? void 0 : _d.setAttribute('style', 'width:85%; overflow-x: hidden');
            var slideElements = Array.from(container[0].getElementsByClassName('swiper-slide'));
            slideElements.map(function (item, index) {
                item.setAttribute('style', 'max-width: fit-content');
            });
            var containerWidth = document.getElementsByClassName('swiper-slide-container')[0];
            var tabElements = Array.from(document.getElementsByClassName('hover-list-tab'));
            var totalElementsWidth = 0;
            var myArray = [];
            slideElements.length > 0 &&
                slideElements.map(function (item, index) {
                    // console.log("empty")
                });
            var hoverListTabs = Array.from(document.getElementsByClassName('hover-list-tab'));
            updateElementsWidth(totalElementsWidth);
        }, 0);
    }, []);
    // useEffect(() => {}, [totalElementWidth, containerWidth]);
    var renderCards = data.tabList.map(function (contentProps, index) {
        if (window.innerWidth < 1020) {
            return (_jsxs("div", __assign({ className: "hover-list-tab", onClick: function () { return updateIndex(index); } }, { children: [' ', contentProps.listText] }), "card-" + index));
        }
        else {
            return (_jsx(SwiperSlide, { children: _jsxs("div", __assign({ className: "hover-list-tab", onClick: function () { return updateIndex(index); } }, { children: [' ', contentProps.listText] }), "card-" + index) }, "card-" + index));
        }
    });
    return window.innerWidth ? (_jsx("section", __assign({ className: "hover-list-tabs-container" }, { children: _jsx(TwoCards, { data: data.tabList }, void 0) }), void 0)) : (_jsx("section", __assign({ className: "hover-list-tabs-container" }, { children: _jsx(CardCarousel, { data: data.tabList }, void 0) }), void 0));
};
